<div class="row">
    <div class="col-md-7">
        <mat-card class="h-100">
            <mat-card-header>
                <mat-card-title>Model Description</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p class="text-justify">{{index.description}}</p>
                <p class="text-bold">All numbers below are based on total return.</p>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="col-md-5">
        <mat-card>
            <mat-card-header>
                <mat-card-title>Model Characteristics</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <table class="table table-cim">
                    <tbody>
                    <tr><th class="text-grey">Region</th><td class="text-end text-bold">{{index.region ? index.region.name : '-'}}</td></tr>
                    <tr><th class="text-grey">Universe</th><td class="text-end text-bold">{{index.universe ? index.universe.name : '-'}}</td></tr>
                    <tr><th class="text-grey">Companies</th><td class="text-end text-bold">{{index.companies ? index.companies.length : 0}}</td></tr>
                    <tr><th class="text-grey">Weighting</th><td class="text-end text-bold">{{index.weighting ? index.weighting.name : '-'}}</td></tr>
                    <tr><th class="text-grey">Rebalancing</th><td class="text-end text-bold">{{index.rebalancing ? index.rebalancing.name : '-'}}</td></tr>
                    <tr><th class="text-grey">Currency</th><td class="text-end text-bold">{{index.currency ? index.currency.name : '-'}}</td></tr>
                    <tr><th class="text-grey">Liquidity Req.</th><td class="text-end text-bold">{{index.liquidityRequirement ? index.liquidityRequirement.name : '-'}}</td></tr>
                    <tr><th class="text-bold">Rebalancing date</th><td class="text-end text-bold">{{index.calculation_date | date: 'yyyy-MM-dd'}}</td></tr>
                    </tbody>
                </table>
            </mat-card-content>
        </mat-card>
    </div>
</div>
